import {message, Modal, notification} from 'antd'
import {deleteLabel} from "../../../../../services/api/labelApi"

/**
 *
 * @param labelId {String}
 * @return {Promise<boolean>}
 */
const reqDeleteLabel = async (labelId) => {
    const {data: response} = await deleteLabel(labelId)

    const {success} = response

    if (!success) throw new Error(response.message)

    return true
}

/**
 *
 * @param labelId {String}
 * @param barcode {String}
 * @param afterDelete {Function}
 * @param label {Object}
 */
export default function (labelId, barcode, afterDelete, label) {
    const {tracking_number} = {...label}

    Modal.confirm({
        title: `Xác nhận xóa nhãn ` + (barcode ? `đơn hàng ${barcode}` : (tracking_number ? `có tracking ${tracking_number}` : 'này') + '?'),
        onOk() {
            reqDeleteLabel(labelId).then(result => {
                message.success('Xóa thành công')

                if (typeof afterDelete === 'function') {
                    afterDelete()
                }
            }).catch(err => {
                notification.error({
                    message: 'ERROR',
                    description: err.message,
                    duration: 0,
                })
            })
        },
    })
}
